function IconTalkTimeAvgBubbles() {
  return (
    <svg
      width="117"
      height="49"
      viewBox="0 0 117 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M48.2344 21.4375C48.2344 10.7188 37.8219 2.29688 24.5 2.29688C11.1781 2.29688 0.765625 10.7188 0.765625 21.4375C0.765625 32.2328 11.4078 40.9609 24.5 40.9609C26.6437 40.9609 28.7875 40.7312 30.8547 40.1953L42.5687 45.0187C42.6453 45.1719 42.7984 45.1719 42.875 45.1719C43.0281 45.1719 43.1812 45.0953 43.3344 45.0187C43.5641 44.8656 43.6406 44.6359 43.6406 44.3297L42.875 33.7641C46.3203 30.3187 48.2344 25.9547 48.2344 21.4375Z"
          fill="white"
        />
      </g>
      <g opacity="0.5">
        <path
          d="M71.5312 29.875C71.5312 22.4375 78.7563 16.5938 88 16.5938C97.2437 16.5938 104.469 22.4375 104.469 29.875C104.469 37.3656 97.0844 43.4219 88 43.4219C86.5125 43.4219 85.025 43.2625 83.5906 42.8906L75.4625 46.2375C75.4094 46.3437 75.3031 46.3438 75.25 46.3438C75.1437 46.3438 75.0375 46.2906 74.9313 46.2375C74.7719 46.1312 74.7188 45.9719 74.7188 45.7594L75.25 38.4281C72.8594 36.0375 71.5312 33.0094 71.5312 29.875Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export { IconTalkTimeAvgBubbles };
